import { render, staticRenderFns } from "./EditarRegiao.vue?vue&type=template&id=2c68cf98"
import script from "./EditarRegiao.vue?vue&type=script&lang=js"
export * from "./EditarRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports